'use client';

import { useEffect } from 'react';

const ReloadOnPopstate = () => {
  useEffect(() => {
    const handlePopState = () => {
      if (
        [
          '/thank-you',
          '/report',
          '/report/bushfire',
          '/report/cyclone',
          '/report/flood',
          '/report/storm',
        ].includes(window.location.pathname)
      ) {
        return;
      }

      window.location.replace('/landing');
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return null;
};

export default ReloadOnPopstate;
